import React, { useEffect, useState } from "react";
import DashboardTables from "./DashboardTables";
import fetchWithToken from "views/auth/signIn/axiosInstance";

function transformChartObject(obj) {
  if (!obj) return [];
  return Object.entries(obj).map(([key, value]) => ({
    BRANCH: key,
    TRANSACTIONS: value,
    ORDERS: value,
    STATUS: true,
  }));
}

const DashboardAnalyticsCharts = ({ type, companyId, branchId, dateFilter, customRange }) => {
  const [branchData, setBranchData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [itemData, setItemData] = useState([]);

  useEffect(() => {
    if (dateFilter === "custom" && (!customRange.from || !customRange.to)) return;

    // Build query params
    const params = new URLSearchParams();
    params.append("type", type);
    params.append("date_filter", dateFilter);

  if (companyId && companyId !== "all" && companyId !== "null" && companyId !== "") params.append("company_id", companyId);
  if (branchId && branchId !== "all" && branchId !== "null" && branchId !== "") params.append("branch_id", branchId);
    if (dateFilter === "custom") {
      params.append("from", customRange.from);
      params.append("to", customRange.to);
    }

     fetchWithToken(
      `${process.env.REACT_APP_API_URL_Report}analytics/charts?${params.toString()}`,
      "POST"
    )
      .then(res => {
        const charts = res.charts || {};
        setBranchData(transformChartObject(charts.orders_per_branch));
        setServiceData(transformChartObject(charts.services));
        setItemData(transformChartObject(charts.items));
      })
      .catch(() => {
        setBranchData([]);
        setServiceData([]);
        setItemData([]);
      });
  }, [type, companyId, branchId, dateFilter, customRange]);

  return (
    <DashboardTables
      branchData={branchData}
      serviceData={serviceData}
      itemData={itemData}
    />
  );
};

export default DashboardAnalyticsCharts;
